// extracted by mini-css-extract-plugin
export default {"container":"style_container__3t9R4","label":"style_label__2rXfk","select":"style_select__+p+44"};